import { type ApiContainerFollowUpOffer } from '@Model';
import {
    type ApiActionOption,
    type ApiMessageAction,
    EnumMessageAction,
    useActionMessage,
    useOnTheFlyModal,
    useTranslate,
} from '@synqo/frontend-component-library';
import { useCallback } from 'react';
import { ContainerFollowUpModal } from '@Modules/Orders/Editing/Containers';

const isContainerFollowUpOffer = (message: ApiMessageAction) =>
    message.action === EnumMessageAction.LoadRelatedData && message.resource_type === 'container_follow_ups';

const openOffers = new Set<string>();

const leaveToTheNotification = () => undefined;

/**
 * Opens the modal that carries a booked placement over to its follow-ups once the user views the offer in its
 * notification.
 *
 * @param openOrder Opens an order of a chain on top of the modal.
 */
// @ai-generated 2026-10-16T15:07:50+00:00 by malte.ulfers@tngtech.com using Claude Opus 5.5 (1M context)
export function useContainerFollowUpOffer(openOrder: (orderId: string) => void): void {
    const i18n = useTranslate('');
    const { openOnTheFlyModal, closeOnTheFlyModals } = useOnTheFlyModal();

    const open = useCallback(
        (_option: ApiActionOption, message: ApiMessageAction) => {
            const offer = JSON.parse(message.options[0].value) as ApiContainerFollowUpOffer;
            const key = offer.source.container_action_ids.join(',');
            if (openOffers.has(key)) {
                return;
            }

            openOffers.add(key);
            const modalId: string = openOnTheFlyModal({
                header: { title: i18n('Container-Daten übernehmen?') },
                child: (
                    <ContainerFollowUpModal
                        offer={offer}
                        onDone={() => closeOnTheFlyModals(modalId)}
                        onOpenOrder={openOrder}
                    />
                ),
                onClose: () => openOffers.delete(key),
            });
        },
        [i18n, openOnTheFlyModal, closeOnTheFlyModals, openOrder],
    );

    useActionMessage({
        canHandle: isContainerFollowUpOffer,
        handleMessage: leaveToTheNotification,
        handleOption: open,
    });
}
